import React from "react";
import { Table } from "antd";
import { withRouter } from "react-router-dom";
import VehicleName from "../../../VehicleName";

const CustomerTable = (props) => {
  const { dataSource, pagination, spinner, history } = props;

  const columns = [
    {
      title: "Customer",
      dataIndex: "saleData",
      key: "customer",
      render: (saleData) => saleData?.customerName || "-",
    },
    {
      title: "Phone",
      dataIndex: "saleData",
      key: "phone",
      render: (saleData) => {
        const contacts = saleData?.customer?.contacts || [];
        if (contacts.length === 0) return "-";
        return contacts.map((cont) => cont.phone).join(", ");
      },
    },
    {
      title: "Vehicle",
      dataIndex: "saleData",
      key: "vehicle",
      width: 260,
      render: (saleData) => (
        <VehicleName nameOnly value={saleData?.vehicle} fallback="-" />
      ),
    },
    {
      title: "Branch",
      dataIndex: "saleData",
      key: "branch",
      render: (saleData) => saleData?.branch?.name || "-",
    },
    {
      title: "Executive",
      dataIndex: "saleData",
      key: "executive",
      render: (saleData) => saleData?.executive?.profile?.employeeName || "-",
    },
  ];

  const handleRowClick = (record) => {
    const contacts = record?.saleData?.customer?.contacts || [];
    if (contacts.length > 0) {
      const primaryPhone = contacts[0].phone;
      history.push({
        pathname: `/autoadmin/sales_feedback_call/${primaryPhone}`,
        state: {
          saleId: record.id,
          status: props.status
        },
      })
    }
  };

  return (
    <Table
      loading={spinner}
      columns={columns}
      dataSource={dataSource}
      pagination={pagination}
      rowKey={(record) => record.id}
      onRow={(record) => ({
        onClick: () => handleRowClick(record),
        style: { cursor: "pointer" },
      })}
      scroll={{ x: true }}
    />
  );
};

export default withRouter(CustomerTable);
